var ApplicationsAPI = require("../../../common/api/application");
var EvaluationsAPI = require("../../../common/api/evaluation");
var DonationsAPI = require("../../../common/api/donation");
var RepositoryAPI = require("../../../common/api/repository");
var UserAPI = require("../../../common/api/user");
var social = require("../../../common/social");

var _ = require("underscore");
var moment = require("moment");
const { emit } = require("superagent");

module.exports = function ProjectPublicController(
	$scope,
	$state,
	$stateParams,
	$rootScope,
	ngDialog,
	$location,
	$timeout
) {
	var vm = this;
//	vm.location = $location.absUrl();
	vm.loggedIn = !!$rootScope.auth;
	vm.commentUserName = "";

	vm.fundingExpired = null;

	vm.applicantDirectlyBenefittingAnnually = "";
	vm.applicantManagementType = "";
	vm.applicantLegalStatus = "";
	vm.unallocatedPercentage = 0;
	vm.editable = false;
	vm.donations = [];
	vm.grantOffers = [];
	vm.matchOffers = [];
	vm.updates = [];
	vm.updateLimit = 10;
	vm.comments = [];
	vm.events = [];
	vm.applicationEvaluationLabels = [];
	vm.evaluationPartiallyComplete = false;
	vm.isTheFunder = false;

	vm.application = {};
	/* 
		Expected fields
		-----------------
		fundingRequiredDate
		grandTotalRaised
		totalRaised
		totalRequested
		totalExternallyRaised
		isOwner
		coverPicture
		coverPictureUrl
		projectTitle
		projectSummary
		organisationName
		projectDetails
		projectType
		capitalProjectType
		revenueCostTypesList
		areaServed

		charitableCategories: [{	
				areaName, rootAreaName
			}]
		directBeneficiaries
		indirectBeneficiaries
		beneficiaryAgeRanges
		howBenefitLocalCommunity
		breakdownCosts: {
			colmnNames: [],
			data: [] 
		},

		workLocations: [{areaName}],
		remainingToRaise
		status: {id}

		isFundraiser

		applicant: [{areaServced, charitableCategories,	socialMediaItems, applicantLegalStatuses, managementType, directlyBenefitting}]
		fundraiserProfiles: [{profilePictureUrl, title, publicUrl, totalRequested, totalExternallyRaised  }]
		matchFundings: [{offered, remaining, matchingDonations, matchingGrants}]
	*/

	vm.barometer = {};
	var calculateEventCounts = function() {
		vm.pastEvents = 0;
		_.each(vm.events, function(event) {
			if (moment(event.eventStartTime).valueOf() < moment().valueOf())
				vm.pastEvents++;
			var addressLines = [];
			var address = event.address;
			if (address.addressLine1)
				addressLines.push(address.addressLine1);
			if (address.addressLine2)
				addressLines.push(address.addressLine2);
			if (address.townOrCity)
				addressLines.push(address.townOrCity);
			if (address.countyOrState)
				addressLines.push(address.countyOrState);
			if (address.postcodeOrZip)
				addressLines.push(address.postcodeOrZip);
			event.addressLines = addressLines;
		});
		vm.futureEvents = vm.events.length - vm.pastEvents;
	};

	vm.increaseUpdateLimit = function() {
		vm.updateLimit += 10;
	};

	var rebuildUpdates = function() {
		_.each(vm.donations, function(update) {
			update.type = "DONATION";
		});
		_.each(vm.comments, function(update) {
			update.type = "COMMENT";
		});
		_.each(vm.grantOffers, function(update) {
			update.type = "GRANTOFFER";
			update.nameAlias = update.funder;
			if (update.confirmedOn) {
				update.createdDate = update.confirmedOn;
			} else {
				update.createdDate = update.submittedOn;
			}
			update.userId = update.createdByUserId;
		});
		_.each(vm.matchOffers, function(update) {
			update.nameAlias = update.funder;
			update.type = "MATCHOFFER";
			_.each(update.matchFunding.matchFundingRules, function(rule) {
				if (update.confirmedOn) {
					update.createdDate = update.confirmedOn;
				} else {
					update.createdDate = update.submittedOn;
				}
			});
			update.userId = update.createdByUserId;
		});

		var combinedUpdates = _.union(
			vm.donations,
			vm.comments,
			vm.grantOffers,
			vm.matchOffers
		);
		var sortedUpdates = _.sortBy(combinedUpdates, function(item) {
			return item.createdDate;
		});
		vm.updates = sortedUpdates.reverse();
	};

	vm.init = function() {
		vm.loading = true;
		vm.loadFailed = false;

		ApplicationsAPI.GetFromUserRef(
			$stateParams.applicationUserRef,
			"ApplicationTitleView"
		).then(function(result) {
			$scope.applicationId = result.id;
			$scope.userRef = result.userRef;
			vm.allowFunding = result.allowFunding;

			if (result.projectTitle) {
				document.title = result.projectTitle;
			}

			var donationPromise = ApplicationsAPI.GetDonations(
				$scope.applicationId,
				null,
				"DonationMessageView",
				3000
			);
			donationPromise.then(function(result) {
				vm.donations = result.results;
				rebuildUpdates();
			});
			ApplicationsAPI.GetGrantOffers(
				$scope.applicationId,
				"GrantOfferMessageView"
			).then(function(result) {
				vm.grantOffers = result;
				rebuildUpdates();
			});
			ApplicationsAPI.GetMatchOffers(
				$scope.applicationId,
				"MatchOfferMessageView"
			).then(function(result) {
				vm.matchOffers = result;
				rebuildUpdates();
			});

			var initiateDonate = $location.search().donate;
			if (initiateDonate && vm.allowFunding){
				vm.openDonorJourney();
				$location.search("donate", undefined);
			}
		},
		function (result){
			vm.loading = false;
			vm.loadFailed = true;
		});

		ApplicationsAPI.GetFromUserRef(
			$stateParams.applicationUserRef,
			"PublicApplicationDetailsView"
		).then(function(result) {
			vm.loading = false;

			// Application is editable if user is an applicant, and status is not StoppedByAdmin 
			vm.canEditApplication = false;
			if ($rootScope.auth && $rootScope.auth.user_id) {
				var user_id = $rootScope.auth.user_id.toString();
				if (result.status && result.status.id != 40 /*StoppedByAdmin*/ && 
					result.applicant && result.applicant.users) {

					if (
						_.any(result.applicant.users, function(user) {
							return user.userId.replace(/-/g, "") == user_id;
						})
					) {
						vm.canEditApplication = true;
					}
				}
			}
			vm.application = result;
			vm.fundingExpired = moment(vm.application.fundingRequiredDate) < moment.utc();
			var perc = Math.floor(
				vm.application.grandTotalRaised /
					(vm.application.totalRequested +
						vm.application.totalExternallyRaised) *
					100
			);
			if (perc > 100) {
				vm.application.percentage = 100;
			} else if (perc <= 0) {
				vm.application.percentage = 0;
			} else {
				vm.application.percentage = perc;
			}

			// convert cover picture object naming required for photo upload directive
			if (vm.application.coverPicture) {
				vm.application.coverPicture.blobId =
					vm.application.coverPicture.documentId;
			}

			var twitter = social.filterBy(
				vm.application.applicant.socialMediaItems || [],
				social.TWITTER
			);
			vm.twitterUsername = twitter.length
				? social.getUsername(twitter[0])
				: null;

			vm.barometer = {
				left: vm.application.grandTotalRaised,
				right: vm.application.remainingToRaise,
				divider:
					vm.application.totalRequested +
						vm.application.totalExternallyRaised
			};
			vm.application.applicant.applicantLegalStatuses.forEach(function(
				item
			) {
				if (item.checked) {
					vm.applicantLegalStatus += item.name + ", ";
				}
			});
			if (vm.applicantLegalStatus.length > 2) {
				vm.applicantLegalStatus = vm.applicantLegalStatus.slice(0, -2);
			}
			vm.remaining =
				vm.application.totalRequested +
				vm.application.totalExternallyRaised -
				vm.application.totalRaised;

			if (vm.application.totalRaised && vm.application.totalRequested) {
				vm.application.percentage = Math.floor(
					vm.application.totalRaised /
						(vm.application.totalRequested +
							vm.application.totalExternallyRaised) *
						100
				);
			} else {
				vm.application.percentage = 0;
			}

			if (vm.application.applicant.managementType) {
				switch (vm.application.applicant.managementType) {
					case 1:
						vm.applicantManagementType = "Board of Directors";
						break;
					case 2:
						vm.applicantManagementType = "Trustees";
						break;
					case 3:
						vm.applicantManagementType = "Management Committee";
						break;
					case 4:
						vm.applicantManagementType = "Council";
						break;
					default:
						vm.applicantManagementType = "Other";
						break;
				}
			}

			if (vm.application.applicant.directlyBenefitting) {
				switch (vm.application.applicant.directlyBenefitting) {
					case 1:
						vm.applicantDirectlyBenefittingAnnually = "1-10";
						break;
					case 2:
						vm.applicantDirectlyBenefittingAnnually = "11-25";
						break;
					case 3:
						vm.applicantDirectlyBenefittingAnnually = "26-50";
						break;
					case 4:
						vm.applicantDirectlyBenefittingAnnually = "51-100";
						break;
					case 5:
						vm.applicantDirectlyBenefittingAnnually = "101-250";
						break;
					case 6:
						vm.applicantDirectlyBenefittingAnnually = "251-500";
						break;
					case 7:
						vm.applicantDirectlyBenefittingAnnually = "501-1000";
						break;
					default:
						vm.applicantDirectlyBenefittingAnnually = "Over 1000";
						break;
				}
			}

			vm.unallocatedPercentage = 100 - vm.application.percentage;
			result.applicationComments.forEach(function(item) {
				var formattedId = item.userId.replace(/-/g, "");
				if ($rootScope.auth) {
					if (formattedId == $rootScope.auth.user_id)
						item.isCreator = true;
				}
				vm.comments.push(item);
			});
			vm.galleryItems = result.applicationGalleryItems;

			if (vm.galleryItems.length > 0) {
				vm.galleryItemsShow = true;
			} else {
				vm.galleryItemsShow = false;
			}

			vm.application.fundraiserProfiles.forEach(function(item) {
				item.barometer = {};
				item.barometer.left = item.raised;
				//var total = Math.max(item.totalRequested, item.raised);
				//item.barometer.right = total - item.raised;
				//item.barometer.divider = total;
                item.barometer.right = item.totalRequested - item.raised;
                item.barometer.divider = item.totalRequested;

				var perc = Math.floor((item.raised * 100) / item.totalRequested);
				if (perc <= 0) {
					item.barometer.percentage = 0;
				} else {
					item.barometer.percentage = perc;
				}

				if (item.profilePicture) {
					var formattedId = item.profilePicture.blobId.replace(
						/-/g,
						""
					);
					item.profilePictureUrl = encodeURI(
						window.conf.doc_repos_url +
							"get/" +
							encodeURIComponent(formattedId) +
							"/" +
							item.profilePicture.fileName
					);
				}
			});

			vm.application.remainingToRaise = Math.max(vm.application.remainingToRaise, 0);
			vm.totalFundingOffered = vm.application.matchFundings.reduce(function(a, b) { return a + b.offered;}, 0);
			vm.totalFundingRemaining = vm.application.matchFundings.reduce(function(a, b) { return a + (b.expired ? 0 : b.remaining);}, 0);

			vm.events = result.applicationEvents;
			vm.breakdownCosts = result.costBreakdown;
			calculateEventCounts();
			rebuildUpdates();
			getEvaluationReportLabels();

			if (vm.scrollToDonations){
				window.setTimeout(function(){
					scrollToShow('project-updates');
				}, 0);
				vm.scrollToDonations = false;
			}
		},
		function (result){
			var a = result;
			vm.loading = false;
			vm.loadFailed = true;
		});
	};

	getEvaluationReportLabels = function() {
		EvaluationsAPI.GetEvaluationReportLabels(
			vm.application.id
		).then(function(result) {
			vm.applicationEvaluationLabels = result;
			getReportDetails(result);
		});
	};

	getReportDetails = function(reports) {
		vm.donations.forEach(function(item) {
			if (item.userId && $rootScope.auth) {
				var formattedId = item.userId.replace(/-/g, "");
				if (formattedId == $rootScope.auth.user_id) {
					vm.isTheFunder = true;
				}
			}
		});
		reports.forEach(function(item) {
			EvaluationsAPI.GetEvaluationReportDetails(
				item.reportId
			).then(function(result) {
				if (
					result.objectiveMetStatus == 10 ||
					result.benefitsStatus == 10 ||
					result.costBreakdownStatus == 10 ||
					result.publicDocumentsStatus == 10 ||
					(result.privateDocumentsStatus == 10 &&
						(vm.isTheFunder || vm.canEditApplication))
				) {
					vm.evaluationPartiallyComplete = true;
				}
			});
		});
	};

	vm.openProjectSummary = function() {
		var dialog = ngDialog.open({
			template: require("./dialogs/projectSummary.pug")(),
			controller: require("./dialogs/projectSummary"),
			plain: true,
			disableAnimation: true,
			className: "ge-dialog-medium ngdialog-theme-default",
			resolve: {
				projectSummary: function() {
					return vm.application.projectSummary;
				}
			}
		});
		dialog.closePromise.then(function(data) {
			if (data.value.action == "submit") {
				vm.application.projectSummary = data.value.projectSummary;
				ApplicationsAPI.UpdateApplicationSummary($scope.applicationId, {
					applicationSummary: vm.application.projectSummary
				});
			}
		});
	};
	vm.openProjectDetails = function() {
		var dialog = ngDialog.open({
			template: require("./dialogs/projectDetails.pug")(),
			controller: require("./dialogs/projectDetails"),
			plain: true,
			disableAnimation: true,
			className: "ge-dialog-medium ngdialog-theme-default",
			resolve: {
				projectDetails: function() {
					return vm.application.projectDetails;
				}
			}
		});
		dialog.closePromise.then(function(data) {
			if (data.value.action == "submit") {
				vm.application.projectDetails = data.value.projectDetails;
				ApplicationsAPI.UpdateApplicationDetails($scope.applicationId, {
					applicationDetails: vm.application.projectDetails
				});
			}
		});
	};

	vm.openProjectEvaluation = function() {
		var dialog = ngDialog.open({
			template: require("./dialogs/projectEvaluation.pug")(),
			controller: require("./dialogs/projectEvaluation"),
			plain: true,
			disableAnimation: true,
			className: "ge-dialog-medium ngdialog-theme-default",
			resolve: {
				applicationEvaluationLabels: function() {
					return vm.applicationEvaluationLabels;
				},
				application: function() {
					return vm.application;
				},
				canEditApplication: function() {
					return vm.canEditApplication;
				},
				isFunder: function() {
					return vm.isTheFunder;
				}
			}
		});
		return dialog;
	};

    vm.openDonorJourney = function () {
        angular.element(document).find('body').addClass('scrollLock')

        var dialog = ngDialog.open({
            template: require("./dialogs/donorJourney.pug")(),
            controller: require("./dialogs/donorJourney"),
            data: {
                applicationId: $scope.applicationId
                },
            plain: true,
            disableAnimation: true,
            className: "ngdialog-theme-default ngdialog-theme-dcsl ngdialog-disabled-animation ngdialog-large",
            showClose: false,
            closeByDocument: false,
            closeByEscape: false,
            resolve: {
                application: function () {
                    return vm.application;
                }
            }
        });

        dialog.closePromise.then(function (data) {
            angular.element(document).find('body').removeClass('scrollLock')

            var value = data.value;
			if (value.action === 'close') {
				if (value.viewDonation) {
					vm.scrollToDonations = true;
				}
				vm.init();
			}
        });

        return dialog;
    };

	vm.openProjectImages = function() {
		var dialog = ngDialog.open({
			template: require("./dialogs/projectImages.pug")(),
			controller: require("./dialogs/projectImages"),
			plain: true,
			disableAnimation: true,
			className:
				"ngdialog-theme-default ngdialog-theme-upload ngdialog-theme-image-gallery",
			resolve: {}
		});
		dialog.closePromise.then(function(data) {
			if (data.value.action == "submit") {
				//Save new images
				//Get new images
			}
		});
	};

	vm.addComment = function() {
		if (
			_.any(vm.comments, function(comment) {
				return comment.editMode;
			})
		)
			return;
		vm.comments.push({
			createdDate: moment().format("MMMM Do YYYY, h:mm:ss a"),
			type: "COMMENT",
			editMode: true,
			isFocused: true
		});
		rebuildUpdates();
	};

	vm.editComment = function(comment) {
		comment.editMode = true;
		comment.isFocused = true;
	};

	vm.submitComment = function(comment) {
		comment.editMode = false;
		comment.sendingToServer = true;
		if (comment.id) {
			ApplicationsAPI.UpdateComment($scope.applicationId, comment.id, {
				text: comment.text
			}).then(function() {
				comment.sendingToServer = false;
			});
		} else {
			comment.createdDate = moment();
			ApplicationsAPI.CreateComment(
				$scope.applicationId,
				comment
			).then(function(result) {
				comment.id = result;
				if ($rootscope.auth) {
					if ($rootScope.auth.user_id == comment.userId) {
						comment.isCreator = true;
					}
				}
				comment.sendingToServer = false;
			});
		}
		vm.init();
	};

	/*EVENTS*/
	vm.toggleEventDetails = function(event) {
		event.expanded = !event.expanded;
	};

	var openEventDialog = function(event) {
		var dialog = ngDialog.open({
			template: require("./dialogs/event.pug")(),
			controller: require("./dialogs/event"),
			plain: true,
			closeByDocument: false,
			disableAnimation: true,
			className: "ge-dialog-medium ngdialog-theme-default",
			resolve: {
				event: function() {
					return event ? angular.copy(event) : null;
				}
			}
		});
		return dialog;
	};

	vm.addEvent = function() {
		var dialog = openEventDialog();
		dialog.closePromise.then(function(data) {
			returnedEvent = data.value.event;
			if (!returnedEvent) return;
			ApplicationsAPI.AddEvent(
				$scope.applicationId,
				returnedEvent
			).then(function(result) {
				vm.init();
			});
		});
	};

	vm.editEvent = function(event) {
		var dialog = openEventDialog(angular.copy(event));
		dialog.closePromise.then(function(data) {
			var returnedEvent = data.value.event;
			var returnedAction = data.value.action;
			if (returnedAction == "delete") {
				vm.deleteEvent(angular.copy(returnedEvent));
			}
			if (returnedAction == "submit") {
				ApplicationsAPI.UpdateEvent(
					$scope.applicationId,
					returnedEvent.id,
					returnedEvent
				).then(function() {
					return vm.init();
				});
			}
		});
	};

	vm.deleteEvent = function(event) {
		var dialog = ngDialog.open({
			template: require("./dialogs/deleteEvent.pug")(),
			controller: require("./dialogs/deleteEvent"),
			plain: true,
			disableAnimation: true
		});
		dialog.closePromise.then(function(data) {
			if (data.value.action == "submit") {
				UserAPI.DeleteApplicationEvent(event.id).then(function() {
					return vm.init();
				});
			} else {
				vm.editEvent(event);
			}
		});
	};

	vm.getAvatar = function(id) {
		return window.conf.ge_api + "users/" + id + "/avatar";
	};

	vm.maskDonation = function($event, update) {
		$event.preventDefault();

		var promise = ngDialog.openConfirm({
			template:
				'\
              <p>Are you sure you want to hide the message and anonymise this donation?</p>\
              <div class="ngdialog-buttons clearfix">\
                  <button type="button" class="btn btn-green btn-sm pull-xs-right m-l-1" ng-click="closeThisDialog(0)">No</button>\
                  <button type="button" class="btn btn-danger btn-sm pull-xs-right" ng-click="confirm(1)">Yes</button>\
              </div>',
			plain: true,
			disableAnimation: true
		});
		promise.then(function() {
			update.isMasked = true;
			DonationsAPI.MaskDonation(update.id).finally(function() {
				return vm.init();
			});
		});
	};

	vm.init();

	var dialogs = {
		gallery: {
			template: require("./dialogs/gallery.pug")(),
			controller: require("./dialogs/gallery")
		},
		video: {
			template: require("./dialogs/video.pug")(),
			controller: require("./dialogs/video")
		}
	};

	var addGalleryItemModalCallback = function(data) {
		var item = data.value.item;
		if (item) {
			// vm.galleryItems.push(item);
			ApplicationsAPI.AddGalleryItem(
				$scope.applicationId,
				item
			).then(function(result) {
				// item.id = result;
				vm.init();
			});
		}
	};

	vm.addGalleryVideo = function() {
		var item = {};
		var dialog = openGalleryDialog(item, "video");

		dialog.closePromise.then(addGalleryItemModalCallback);
	};

	var openGalleryDialog = function(item, dialogName) {
		if (!dialogName) dialogName = "gallery";
		var template = dialogs[dialogName].template;
		var controller = dialogs[dialogName].controller;
		var dialog = ngDialog.open({
			template: template,
			controller: controller,
			plain: true,
			closeByDocument: false,
			disableAnimation: true,
			resolve: {
				item: function() {
					return item;
				}
			}
		});
		return dialog;
	};

	vm.addGalleryItem = function() {
		var item = {};
		var dialog = openGalleryDialog(item);
		dialog.closePromise.then(addGalleryItemModalCallback);
	};

	vm.editGalleryItem = function(item, event) {
		event.preventDefault();
		event.stopPropagation();
		var modalType = "gallery";
		if (item.isVideo) modalType = "video";
		var dialog = openGalleryDialog(_.clone(item), modalType);
		dialog.closePromise.then(function(data) {
			var item = data.value.item;
			if (item) {
				item.createdDate = moment().format("YYYY-MM-DDThh:mm:ss");
				_.extend(_.findWhere(vm.galleryItems, { id: item.id }), item);
				ApplicationsAPI.UpdateGalleryItem(
					$scope.applicationId,
					item.id,
					item
				).then(function(result) {
					item.id = result;
				});
			}
		});
	};

	vm.deleteGalleryItem = function(item, event) {
		event.preventDefault();
		event.stopPropagation();
		var promise = ngDialog.openConfirm({
			template:
				'\
                <p>Are you sure you want to delete this item?</p>\
                <div class="ngdialog-buttons clearfix">\
                    <button type="button" class="btn btn-green btn-sm pull-xs-right m-l-1" ng-click="closeThisDialog(0)">No</button>\
                    <button type="button" class="btn btn-danger btn-sm pull-xs-right" ng-click="confirm(1)">Yes</button>\
                </div>',
			plain: true,
			disableAnimation: true
		});
		promise.then(function() {
			ApplicationsAPI.DeleteGalleryItem(
				$scope.applicationId,
				item.id
			).then(function() {
				vm.galleryItems = _.without(
					vm.galleryItems,
					_.findWhere(vm.galleryItems, { id: item.id })
				);
			});
		});
	};

	vm.becomeFundraiser = function() {
		if ($rootScope.auth) {
			var dialog = ngDialog.open({
				template: require("./dialogs/becomeFundraiser.pug")(),
				controller: require("./dialogs/becomeFundraiser"),
				plain: true,
				disableAnimation: true
			});
			dialog.closePromise.then(function(data) {
				if (data.value.action == "submit") {
					UserAPI.CreateFundraisingProfile($scope.applicationId)
						.then(function(id) {
							window.location =
								"/account/fundraisingprofile/" + id;
						})
						.catch(function(exception) {
							var errorDialog = ngDialog.open({
								template: require("./dialogs/fundraiserProfileError.pug")(),
								controller: require("./dialogs/fundraiserProfileError"),
								plain: true,
								disableAnimation: true,
								resolve: {
									item: function() {
										return exception.body.message;
									}
								}
							});
						});
				}
			});
		} else {
			var dialog = ngDialog.open({
				template: require("./dialogs/becomeFundraiserLoggedOut.pug")(),
				controller: require("./dialogs/becomeFundraiserLoggedOut"),
				plain: true,
				disableAnimation: true
			});

			dialog.closePromise.then(function(data) {
				if (data.value.action == "submit") {
					window.location =
						"/login?redirect=" +
						encodeURIComponent("/project/" + $scope.applicationId);
				}
			});
		}
	};

	vm.joinEvent = function(event) {
		var dialog = ngDialog.open({
			template: require("./dialogs/joinEvent.pug")(),
			controller: require("./dialogs/joinEvent"),
			plain: true,
			disableAnimation: true,
			resolve: {
				existingFundraiser: function() {
					return vm.application.fundraiserProfileId;
				}
			}
		});
		dialog.closePromise.then(function(data) {
			if (data.value.action == "submit") {
				if (vm.application.fundraiserProfileId) {
					UserAPI.JoinApplicationEvent(
						vm.application.fundraiserProfileId,
						event.id
					).then(function() {
						window.location =
							"/account/fundraisingprofile/" +
							vm.application.fundraiserProfileId;
					});
				} else {
					UserAPI.CreateFundraisingProfile(
						$scope.applicationId
					).then(function(id) {
						UserAPI.JoinApplicationEvent(
							id,
							event.id
						).then(function() {
							window.location =
								"/account/fundraisingprofile/" + id;
						});
					});
				}
			}
		});
	};

	vm.joinEventLogin = function(event) {
		var dialog = ngDialog.open({
			template: require("./dialogs/joinEventLoggedOut.pug")(),
			controller: require("./dialogs/joinEventLoggedOut"),
			plain: true,
			disableAnimation: true
		});

		dialog.closePromise.then(function(data) {
			if (data.value.action == "submit") {
				window.location =
					"/login?redirect=" +
					encodeURIComponent(
						"/project/" +
							$stateParams.id +
							"/" +
							$stateParams.applicantName +
							"/" +
							$stateParams.projectName
					);
			}
		});
	};

	vm.leaveEvent = function(event) {
		var dialog = ngDialog.open({
			template: require("./dialogs/leaveEvent.pug")(),
			controller: require("./dialogs/leaveEvent"),
			plain: true,
			disableAnimation: true
		});
		dialog.closePromise.then(function(data) {
			if (data.value.action == "submit") {
				UserAPI.LeaveApplicationEvent(
					vm.application.fundraiserProfileId,
					event.id
				).then(function() {
					vm.init();
				});
			} else {
				vm.init();
			}
		});
	};

	vm.updateCoverPicture = function() {
		var lowQualityImage = {};
		if (Array.isArray(vm.application.coverPicture)) {
			lowQualityImage = vm.application.coverPicture[1];
			vm.application.coverPicture = vm.application.coverPicture[0];
		}
		return ApplicationsAPI.UpdateApplicationCoverPicture(
			$scope.applicationId,
			{
				coverPicture: vm.application.coverPicture,
				LowQualityCoverPicture: lowQualityImage
			}
		);
	};

	function getQuestionByText(text, questions) {
		var foundQuestion = null;

		// look through all questions in all groups in all steps
		// if a matching question found, set foundQuestion to it
		questions.steps.forEach(function(step) {
			step.groups.forEach(function(group) {
				group.questions.forEach(function(question) {
					if (question.text == text) foundQuestion = question;
				});
			});
		});

		return foundQuestion;
	}

	function scrollToShow(elementId) {
		const element = document.getElementById(elementId);
		const rect = element.getBoundingClientRect() // get rects(width, height, top, etc)
		const viewHeight = Math.max(document.documentElement.clientHeight, 
									window.innerHeight || 0);
		
		window.scrollBy({
		  top: rect.top - (viewHeight / 4),
		  behavior: 'smooth' // smooth scroll
		});
	}
};

